import { api } from '@/api'
// // import Raven from 'raven-js'
// import types from '/src/store/types'

export default {
  reserveTable: ({commit, getters}, formData) => new Promise((resolve, reject) => {
    let requestData = {
      formData: formData,
      clientData: {}
    }

    api.reserveTable(requestData).then(response => {
      resolve(response.body)
    }).catch(error => {
      console.log('error', error)
      reject(error)
    })
  })
}



// WEBPACK FOOTER //
// ./src/store/actions.js